/*
 * Custom Tawk.to chat launcher.
 *
 * Tawk's native launcher renders in a cross-origin iframe and only supports a
 * single solid colour, so it cannot be given the brand gradient. Instead we hide
 * it (Tawk_API.hideWidget) and inject our own gradient button that opens the same
 * chat via Tawk_API.maximize(). If Tawk never loads, the button is never shown,
 * so the page is unaffected.
 *
 * Tawk's onChatMaximized/onChatMinimized callbacks are unreliable when assigned
 * after the widget has loaded, so instead we poll isChatMaximized() and keep the
 * launcher's visibility in sync: shown while the chat is closed, hidden while it
 * is open.
 */
(function () {
  'use strict';

  // Filled white speech bubble on the gradient background.
  var ICON =
    '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
    '<path fill="#ffffff" d="M16 5C9.9 5 5 9.3 5 14.6c0 2.9 1.5 5.6 3.9 7.4-.3 1.9-1.1 3.6-2.3 5 ' +
    '2.5-.4 4.8-1.4 6.7-2.9.9.2 1.8.3 2.7.3 6.1 0 11-4.3 11-9.8S22.1 5 16 5z"/></svg>';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ct-chat-launcher';
  btn.setAttribute('aria-label', 'Open live chat');
  btn.innerHTML = ICON;
  document.body.appendChild(btn);

  window.Tawk_API = window.Tawk_API || {};

  function show() { btn.style.display = 'flex'; }
  function hide() { btn.style.display = 'none'; }

  btn.addEventListener('click', function () {
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      try { window.Tawk_API.maximize(); } catch (e) {}
    }
  });

  function ready() {
    var a = window.Tawk_API;
    return a &&
      typeof a.hideWidget === 'function' &&
      typeof a.maximize === 'function' &&
      typeof a.isChatMaximized === 'function';
  }

  var tries = 0;
  var last = null; // last known "is chat open" state
  var timer = setInterval(function () {
    if (!ready()) {
      if (++tries > 60) clearInterval(timer); // give up after ~24s
      return;
    }
    var open;
    try { open = !!window.Tawk_API.isChatMaximized(); } catch (e) { return; }
    if (open === last) return; // only act on state changes
    last = open;
    if (open) {
      hide(); // chat window is open — hide our launcher
    } else {
      try { window.Tawk_API.hideWidget(); } catch (e) {} // keep native bubble hidden
      show(); // chat closed — show our gradient launcher
    }
  }, 400);
})();
